import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 获取系统机器人列表
export function taskConfigs(params) {
  return request({
    url: URL.rpaRobot.operationRobot.taskConfigs,
    method: 'get',
    params
  })
}

// 获取机器人列表
export function getList(params) {
  return request({
    url: URL.rpaRobot.operationRobot.taskConfigTenants,
    method: 'get',
    params
  })
}

// 新增机器人
export function addRobot(data) {
  return request({
    url: URL.rpaRobot.operationRobot.taskConfigTenant,
    method: 'post',
    data
  })
}

